module.exports = __webpack_public_path__ + "static/media/SPB389_03.9fbbaca8.png";